import store from '@/store';

/* Här lägger du till nya "rättigheter" som du kopplar en eller flera roller till */
// eslint-disable-next-line no-unused-vars
const getCapabilities = roles => {
	const {
		isWebSbaAdmin, isCompanyAdmin, isCustomerAdmin, isAdmin,
		isUser, isBasicUser, hasApiKeyLicense, isBasicUserLight,
		hasChecklistLicense
	} = roles;
	const webSbaAdmin = [isWebSbaAdmin];
	const companyAdmin = [...webSbaAdmin, isCompanyAdmin];
	const customerAdmin = [...companyAdmin, isCustomerAdmin];
	const admin = [...customerAdmin, isAdmin];
	const user = [...admin, isUser];
	const basicUser = [...user, isBasicUser];
	const basicUserLight = [...basicUser, isBasicUserLight];

	return {
		tree_view_full: companyAdmin,
		tree_add_new_customer: companyAdmin,
		tree_see_own_root: customerAdmin,
		tree_view_company_dropdown: webSbaAdmin,
		tree_modify_level: admin,
		tree_move_level: customerAdmin,
		tree_move_level_within_root: customerAdmin,
		tree_move_level_within_company: companyAdmin,
		tree_move_level_globally: webSbaAdmin,

		dashboard_back_past_own_root_node: customerAdmin,
		dashboard_view_all_buildings: admin,
		dashboard_perform_actions_on_content: basicUser,

		statistics_access_view: basicUserLight,

		users_access_view: user,
		users_edit: admin,
		users_link: webSbaAdmin,
		users_link_within_company: companyAdmin,
		users_link_within_own_root: admin,
		users_manage_external_roles: customerAdmin,

		buildings_access_view: user,
		buildings_edit:	admin,
		buildings_view_employee_tab: user,
		buildings_administer_connected_users: admin,
		buildings_link_any_user: companyAdmin,

		floors_edit: admin,
		floor_areas_edit: admin,

		roles_access_view: admin,
		roles_edit: admin,

		checklists_access_view: [...companyAdmin, (isCustomerAdmin && hasChecklistLicense), (isAdmin && hasChecklistLicense)],
		checklists_edit: [...companyAdmin, (isCustomerAdmin && hasChecklistLicense), (isAdmin && hasChecklistLicense)],
		checklists_edit_global_list: webSbaAdmin,
		checklists_set_company: webSbaAdmin,
		checklists_set_customer: companyAdmin,

		documents_access_view: basicUser,
		documents_edit: basicUser,
		documents_upload: admin,

		licenses_access_view: companyAdmin,

		files_edit: admin,

		apikeys_access_view: [...companyAdmin, (isCustomerAdmin && hasApiKeyLicense)], // Should this return false instantly when disabling api keys on license?

		questions_access_view: admin,
		questions_edit: admin,
		questions_set_company_on_category: webSbaAdmin,

		roundplannings_access_view: admin,
		roundplannings_edit: admin,
		roundplannings_perform_round: basicUser,

		fireprotections_access_view: admin,
		fireprotections_edit: admin,
		fireprotections_set_company: webSbaAdmin,

		changelogs_access_view: webSbaAdmin,

		top_panel_fetch_buildings_without_user_id: customerAdmin,

		round_mark_remaining_items_as_ok: companyAdmin,

		global_set_object_as_global: webSbaAdmin
	};
};


export const isAllowedTo = capabilityKey => {
	// Lägg till dom rollerna som ska finnas stöd för
	const roles = {
		isWebSbaAdmin: store.getters['user/isWebSbaAdmin'],
		isCompanyAdmin: store.getters['user/isCompanyAdmin'],
		isCustomerAdmin: store.getters['user/isCustomerAdmin'],
		isAdmin: store.getters['user/isAdmin'],
		isUser: store.getters['user/isUser'],
		isBasicUser: store.getters['user/isBasicUser'],
		isBasicUserLight: store.getters['user/isBasicUserLight'],

		hasApiKeyLicense: store.getters['user/getActiveCustomer']?.license?.apiKey,
		hasChecklistLicense: store.getters['user/getActiveCustomer']?.license?.checklist
	};

	const capabilites = getCapabilities(roles);
	const capabilityArr = capabilityKey in capabilites && capabilites[capabilityKey];

	if (!capabilityArr) {
		return false;
	}

	return capabilityArr.some(value => value);
};
